import Map from 'ol/Map.js';
import Overlay from 'ol/Overlay.js';
import { Feature } from 'ol';
import OverlayPositioning from 'ol/OverlayPositioning';
import { WGisServiceInterface } from './wgis.utils';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { WGisFeatureInterface } from './wgis.utils';
import { WGisVectorEngine } from './wgis.vectorengine';
import { HtmlAstPath } from '@angular/compiler';



export interface WgisTooltipOption {
  map?: Map;
  wgisservice: WGisServiceInterface;
  initial?: string;
  offset?: number[];
  positioning?: OverlayPositioning;
  translation?: string;
  autoPan?: boolean;
}


export class WGisTooltip {
  map: Map;
  // content
  content: string;
  //  Currently drawn feature.
  sketch: WGisFeatureInterface;
  //  The  tooltip element.
  private myTooltipElement: HTMLElement;
  element: Promise<HTMLElement>;
  // Overlay to show the measurement.
  myTooltip: Overlay;
  isStatic = false;
  translatedtooltip: string;
  selected: boolean;
  subscription: Subscription;
  private resolveElement: (element: HTMLElement) => void = undefined;
  constructor(
    protected opt: WgisTooltipOption
  ) {
    this.element = new Promise((resolve, reject) => { this.resolveElement = resolve; });
    this.selected = false;
    if (this.opt.map) {
      this.map = this.opt.map;
      this.createTooltip();
    } else {
      this.opt.wgisservice.pMap.then((map: Map) => {
        this.map = map;
        this.createTooltip();
      });

    }
    this.subscription = this.opt.wgisservice.wgisClearSelection.subscribe(() => { this.dispose(); });
  }

  dispose(): void {
    if (!this.isStatic) {
      return;
    }
    this.subscription.unsubscribe();
    if (this.myTooltipElement) {
      this.myTooltipElement.parentNode.removeChild(this.myTooltipElement);
      this.myTooltipElement = undefined;
    }
    // if (this.sketch) {
    //   try {
    //     const engine: WGisVectorEngine = this.opt.wgisservice.getEngine(this.sketch.getWgisInfo().engineName) as WGisVectorEngine;
    //     if (engine.source) {
    //       // const vectorsource = this.opt.wgisservice.getVectorSource();
    //       engine.source.removeFeature(this.sketch);
    //       engine.source.changed();
    //       this.sketch = undefined;
    //     }
    //   } 
    //   catch (error) {
    //     console.log("feature eliminated");
    //   }
    // }
  }

  static(): void {
    this.isStatic = true;
    this.myTooltipElement.title = this.opt.translation;
    // this.myTooltipElement.classList.add('tooltip-static');
    this.myTooltipElement.className = 'tooltip tooltip-static';
    this.myTooltip.setOffset([0, -7]);
    this.myTooltipElement.onclick = (evt: MouseEvent) => { this.dispose(); };
  }

  disposeOnClick() {
    this.myTooltipElement.onclick = (evt: MouseEvent) => { this.dispose(); };
  }

  notStatic() {
    this.isStatic = false;
  }
  setSelected(selected: boolean): void {
    this.isStatic = true;
    this.myTooltipElement.title = this.opt.translation;
    this.myTooltipElement.className = selected ? 'tooltip tooltip-static selected' : 'tooltip tooltip-static';
    this.myTooltip.setOffset([0, -7]);
  }

  setOffset(offset: number[]): void {
    this.myTooltip.setOffset(offset);
  }

  hide(): void {
    this.myTooltipElement.classList.add('hidden');
  }

  show(): void {
    this.myTooltipElement.classList.remove('hidden');
  }

  appendElement(element: HTMLElement) {
    this.myTooltipElement.append(element);
  }

  append(content: string): void {
    if (this.content) {
      this.content = this.content + content;
    } else {
      this.content = content;
    }
    this.myTooltipElement.innerHTML = this.content;
  }

  text(content: string): void {
    this.content = content;
    if (this.myTooltipElement) {
      this.myTooltipElement.innerHTML = this.content;
    }
  }

  setPosition(coordinate: number[]) {
    this.myTooltip.setPosition(coordinate);
  }

  setFeature(feature: WGisFeatureInterface): void { this.sketch = feature; }

  getFeature(): WGisFeatureInterface { return this.sketch; }

  // * Creates a new help tooltip */
  // createHelpTooltip() {
  //   if (this.helpTooltipElement) {
  //     this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
  //   }
  //   this.helpTooltipElement = document.createElement('div');
  //   this.helpTooltipElement.className = 'tooltip hidden';
  //   this.helpTooltip = new Overlay({
  //     element: this.helpTooltipElement,
  //     offset: [15, 0],
  //     positioning: OverlayPositioning.CENTER_LEFT,
  //   });
  //   this.opt.map.addOverlay(this.helpTooltip);
  // }

  // Creates a new measure tooltip
  protected createTooltip() {
    if (this.myTooltipElement) {
      this.myTooltipElement.parentNode.removeChild(this.myTooltipElement);
    }
    this.myTooltipElement = document.createElement('div');
    this.myTooltipElement.className = 'tooltip' + this.opt.initial ? ' ' + this.opt.initial : ' tooltip-measure';
    this.myTooltip = new Overlay({
      element: this.myTooltipElement,
      offset: this.opt.offset ? this.opt.offset : [0, -15],
      positioning: this.opt.positioning ? this.opt.positioning : OverlayPositioning.BOTTOM_CENTER,
      autoPan: this.opt.autoPan ? this.opt.autoPan : false
    });
    this.map.addOverlay(this.myTooltip);
    this.resolveElement(this.myTooltipElement);
  }

}

